import React from 'react';

import { useDataType } from 'widgets/statspro/js/components/common/hooks/use-data-type';
import { DATA_TYPE } from 'widgets/statspro/js/components/common/config/data-type';
import { composeGetTranslation } from 'common/react/utils/translations';
import { ToggleInput } from 'common/react/components/ToggleInput';
import { useSelector } from 'react-redux';
import { playerStatsDataTypeSelector } from 'store/modules/mc-player-stats/selectors';
import { setDataType } from 'common/store/modules/mc-player-stats/init';

export const dataTypeOptions = [
    {
        label: composeGetTranslation('label.statsLeaders.dataType.')(
            DATA_TYPE.MATCH
        ),
        value: DATA_TYPE.TOTALS
    },
    {
        label: composeGetTranslation('label.statsLeaders.dataType.')(
            DATA_TYPE.SEASON_AVERAGES
        ),
        value: DATA_TYPE.AVERAGES
    }
];

export const DataTypeToggle = () => {
    const initialDataType = useSelector(playerStatsDataTypeSelector);

    const { dataType, updateDataType } = useDataType({
        initialDataType,
        onUpdateActionCreator: setDataType
    });

    return (
        <ToggleInput
            id="careers-and-season-stats-data-type-toggle"
            value={
                dataType.type.toLowerCase().includes(DATA_TYPE.TOTALS)
                    ? DATA_TYPE.TOTALS
                    : DATA_TYPE.AVERAGES
            }
            onChange={updateDataType}
            options={dataTypeOptions}
        />
    );
};

export default DataTypeToggle;
